import React, { useState } from "react";

const items = [
  {
    question: "Do I need trading experience to use this?",
    answer: "Basic chart familiarity helps, but the platform is designed to make market structure and zones easier to read for developing traders too.",
  },
  {
    question: "Does this guarantee profits?",
    answer: "No. Spike Hunter Online is a decision-support tool, not a profit guarantee. Risk management and execution discipline still matter.",
  },
  {
    question: "Can I use it on mobile?",
    answer: "Yes. The platform layout is built to remain usable across mobile and desktop screen sizes.",
  },
  {
    question: "What happens after the trial ends?",
    answer: "After the 7-day trial, you can continue on the $10/month plan if the workflow fits how you trade. No auto-charge surprises.",
  },
];

function FaqItem({ item, isOpen, onToggle }) {
  return (
    <article className={`landing-faq-item${isOpen ? " landing-faq-item-open" : ""}`}>
      <button type="button" className="landing-faq-trigger" onClick={onToggle}>
        <span>{item.question}</span>
        <span className="landing-faq-symbol" aria-hidden="true">+</span>
      </button>
      <div className="landing-faq-body">
        <p className="landing-faq-answer">{item.answer}</p>
      </div>
    </article>
  );
}

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className="landing-section">
      <div className="landing-section-heading">
        <div className="landing-eyebrow">FAQ</div>
        <h2>Questions traders ask before they start.</h2>
      </div>

      <div className="landing-faq-list">
        {items.map((item, i) => (
          <FaqItem
            key={item.question}
            item={item}
            isOpen={openIndex === i}
            onToggle={() => setOpenIndex(openIndex === i ? -1 : i)}
          />
        ))}
      </div>
    </section>
  );
}
